function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*=============================================================================
 * Copyright (C) 2017 Stephen F. Norledge and Alces Flight Ltd.
 *
 * This file is part of Flight Reactware.
 *
 * All rights reserved, see LICENSE.txt.
 *===========================================================================*/


import { get } from 'lodash';
import { PENDING, RESOLVED, REJECTED } from './constants';
var initialState = {};

function getLoadingStateKey(actionMeta) {
  return get(actionMeta, 'previousAction.meta.loadingState.key') || get(actionMeta, 'loadingState.key');
}

var setLoadingState = function setLoadingState(actionMeta, loadingState) {
  return function (state) {
    var key = getLoadingStateKey(actionMeta);
    return _objectSpread({}, state, _defineProperty({}, key, {
      self: {
        state: loadingState
      }
    }));
  };
}; // Reducer to track the loading state of entities.


export default function reducer(config) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

    var _ref = arguments.length > 1 ? arguments[1] : undefined,
        meta = _ref.meta,
        type = _ref.type;

    switch (type) {
      case config.pending:
        return setLoadingState(meta, PENDING)(state);

      case config.resolved:
        return setLoadingState(meta, RESOLVED)(state);

      case config.rejected:
        return setLoadingState(meta, REJECTED)(state);

      default:
        return state;
    }
  };
}